import(/* webpackMode: "eager" */ "/workspace/apps/sales-pilot-sites/src/app/global-error.tsx");
